import App from './App.svelte';
import "bulma/css/bulma.css";
import './styles/global.css'

const app = new App({
	target: document.body,
});

export default app;
